module.exports = __webpack_public_path__ + "static/media/zeraf-transparent.d15886b0.png";